import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeDeliveryMethodOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			deliveryMethod: '',
        }
    }

    closeDialog(event) {
        event && event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('ChangeDeliveryMethodOverlayDialog', false);
    }

    componentDidMount() {
		const self = this;
		self.setState({
			showDialog: self.props.showDialog,
			deliveryMethod: self.props.deliveryMethod
		});
    }

	onChangeUpdateParam(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	handleContinue(event) {
		event.preventDefault();
		const self = this;
		self.props.changeDeliveryMethod(self.state.deliveryMethod);
	}

    render() {
		const self = this;
		const { deliveryMethod } = self.state;
		let { isSDS_LOC, isSDS_will_call_loc, isAnyMServiceSelectSplitDelivery } = self.props;
        // We cannot send service (M000 codes) on an SDS WIll Call order.
        // If the user selects services to split, can we offer ONLY SDS Delivery
        if (isAnyMServiceSelectSplitDelivery) {
            isSDS_will_call_loc = false;
        }
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="availabilityDetailsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Select Shipping Method</h2>
                    {!isSDS_LOC && !isSDS_will_call_loc && <p className="red">SDS warehouse not found for this address. Please contact customer service to split this delivery</p>}
					{(isSDS_LOC || isSDS_will_call_loc) && <table className="formTableTypeA">
						<tbody>
							{isSDS_LOC && <tr>
								<td>
									<input type="radio" name="deliveryMethod" id="sdsDelivery" onClick={self.onChangeUpdateParam.bind(this)} checked={deliveryMethod === "SDS Delivery"} defaultValue="SDS Delivery"/>
								</td>
								<td>
									<label htmlFor="sdsDelivery"><strong>SDS Delivery</strong></label>
								</td>
							</tr>}
							{isSDS_will_call_loc && <tr>
								<td>
									<input type="radio" name="deliveryMethod" id="sdsWillCall" onClick={self.onChangeUpdateParam.bind(this)} checked={deliveryMethod === "SDS Will Call"} defaultValue="SDS Will Call" />
								</td>
								<td>
									<label htmlFor="sdsWillCall"><strong>SDS Will Call</strong></label>
								</td>
							</tr>}
						</tbody>
					</table>}
					<div>
						<div className="noButtonContainer">
							<a className="noButton blueButton" onClick={self.closeDialog.bind(this)}>Cancel</a>
						</div>
						{(isSDS_LOC || isSDS_will_call_loc) && <div className="yesButtonContainer">
							<a className="blueButton yesButton" onClick={self.handleContinue.bind(this)}>Continue</a>
						</div>}
					</div>
                 </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
});

ChangeDeliveryMethodOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(ChangeDeliveryMethodOverlayDialog);
export default ChangeDeliveryMethodOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeShippingMethodOverlayDialog.js